export const TAGCodeValidator = {
    validate_TAG_CODE($string) {
        let $trimmedStr = $string.trim();
        let pattern = /^[a-zA-Z0-9 ._-]+$/;
        return pattern.test($trimmedStr);
    }
}